/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { EnumDecoder, ObjectData, StringDecoder } from "@simonbackx/simple-encoding";
import { SimpleError } from "@simonbackx/simple-errors";
export var Language;
(function (Language) {
    Language["nl"] = "nl";
    Language["fr"] = "fr";
    Language["en"] = "en";
})(Language || (Language = {}));
export class LanguageHelper {
    static getName(language) {
        switch (language) {
            case Language.nl: return "Nederlands";
            case Language.fr: return "Français";
            case Language.en: return "English";
        }
    }
}
export class TranslatedStringPatch {
    constructor(translations) {
        this.translations = translations;
    }
    patch(patch) {
        const c = new TranslatedStringPatch(Object.assign({}, this.translations));
        for (const key in patch.translations) {
            if (Object.prototype.hasOwnProperty.call(patch.translations, key)) {
                const value = patch.translations[key];
                c.translations[key] = value;
            }
        }
        return c;
    }
    encode(context) {
        if (context.version <= 14) {
            // Don't add English translation
            const val = { ...this.translations, _isPatch: true };
            val[Language.en] = undefined;
            return val;
        }
        return { ...this.translations, _isPatch: true };
    }
}
export class TranslatedString {
    constructor(translations) {
        this.translations = translations;
    }
    append(str) {
        const patch = new TranslatedStringPatch({});
        for (const key in this.translations) {
            if (Object.prototype.hasOwnProperty.call(this.translations, key)) {
                const value = this.translations[key];
                if (typeof str === "string") {
                    patch.translations[key] = value + str;
                }
                else {
                    patch.translations[key] = value + str.get(key);
                }
            }
        }
        return this.patch(patch);
    }
    merge(other) {
        const patch = new TranslatedStringPatch({});
        for (const key in other.translations) {
            if (Object.prototype.hasOwnProperty.call(other.translations, key)) {
                const value = other.translations[key];
                if (value.length > 0) {
                    patch.translations[key] = value;
                }
            }
        }
        return this.patch(patch);
    }
    patch(patch) {
        const c = new TranslatedString(Object.assign({}, this.translations));
        for (const key in patch.translations) {
            if (Object.prototype.hasOwnProperty.call(patch.translations, key)) {
                const value = patch.translations[key];
                if (value === null) {
                    delete c.translations[key];
                }
                else {
                    c.translations[key] = value;
                }
            }
        }
        return c;
    }
    static createPatch(str, language) {
        return new TranslatedStringPatch({ [language]: str });
    }
    getIfExists(language) {
        if (typeof language !== "string") {
            return this.getI18nIfExists(language);
        }
        if (this.translations[language] !== undefined) {
            return this.translations[language];
        }
        return undefined;
    }
    get(language) {
        var _a;
        if (typeof language !== "string") {
            return this.getI18n(language);
        }
        if (this.translations[language] !== undefined) {
            return (_a = this.translations[language]) !== null && _a !== void 0 ? _a : "";
        }
        const keys = Object.keys(this.translations);
        if (keys.length == 0) {
            return "";
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.translations[keys[0]];
    }
    getI18nIfExists(i18n) {
        let lang = i18n.locale.substr(0, 2);
        if (!Object.values(Language).includes(lang)) {
            lang = Language.nl;
        }
        return this.getIfExists(lang);
    }
    getI18n(i18n) {
        let lang = i18n.locale.substr(0, 2);
        if (!Object.values(Language).includes(lang)) {
            lang = Language.nl;
        }
        return this.get(lang);
    }
    encode(context) {
        if (context.version <= 14) {
            // Don't add English translation
            const val = { ...this.translations };
            val[Language.en] = undefined;
            return val;
        }
        return this.translations;
    }
}
export class TranslatedStringPatchDecoderStatic {
    decode(data) {
        if (typeof data.value != "object") {
            throw new SimpleError({
                code: "invalid_field",
                message: "Expected an object",
                field: data.currentField
            });
        }
        const dictionary = new TranslatedStringPatch({});
        for (const key in data.value) {
            if (Object.prototype.hasOwnProperty.call(data.value, key)) {
                if (key == "_isPatch") {
                    continue;
                }
                const language = new EnumDecoder(Language).decode(new ObjectData(key, data.context, data.addToCurrentField(key)));
                const str = data.field(key).nullable(StringDecoder);
                dictionary.translations[language] = str;
            }
        }
        return dictionary;
    }
    patchType() {
        return TranslatedStringPatchDecoder;
    }
    patchIdentifier() {
        throw new Error('A translated string can not be used inside a PatchableArray');
    }
}
export const TranslatedStringPatchDecoder = new TranslatedStringPatchDecoderStatic();
export class TranslatedStringDecoderStatic {
    patchType() {
        return TranslatedStringPatchDecoder;
    }
    patchIdentifier() {
        throw new Error('A translated string can not be used inside a PatchableArray');
    }
    decode(data) {
        if (typeof data.value != "object") {
            throw new SimpleError({
                code: "invalid_field",
                message: "Expected an object",
                field: data.currentField
            });
        }
        const dictionary = {};
        for (const key in data.value) {
            // eslint-disable-next-line no-prototype-builtins
            if (Object.prototype.hasOwnProperty.call(data.value, key)) {
                const language = new EnumDecoder(Language).decode(new ObjectData(key, data.context, data.addToCurrentField(key)));
                const str = data.field(key).string;
                dictionary[language] = str;
            }
        }
        return new TranslatedString(dictionary);
    }
}
export const TranslatedStringDecoder = new TranslatedStringDecoderStatic();
//# sourceMappingURL=Language.js.map